import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { DnRecord, User } from '../../_models';
import { DnRecordService, AuthenticationService, NotificationService, EnvService, KeywordService } from '../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dn-record',
  templateUrl: './dn-record.component.html'
})
export class DnRecordComponent implements OnInit {
  dnRecords: DnRecord[];
  selectedDnRecord: any;
  panOutList = {};
  sourceList = [];
  countryList: any = {};
  operatorList: any = [];
  keywordList: any = [];
  shortCodeList = [];
  loading = false;
  processing = false;
  //pagination
  itemsPerPage = 20;
  pagingList = [20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = true;
  maxPageSize: number;

  //filter
  filterable = {
    source: null,
    shortCode: null,
    keyword: null,
    from: null,
    to: null,
    operator: '',
    phone: '',
    panOutState: '',
    country: ''
  };

  allShortCodes = [];
  targetShortCode = null;

  constructor(private fb: FormBuilder,
    private envSvc: EnvService,
    private keywordSvc: KeywordService,
    private authSvc: AuthenticationService,
    private dnRecordSvc: DnRecordService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 1);
    this.filterable.from = dte.toISOString().substring(0, 10);

    this.loadSources();
    this.loadPanOutStates();
    this.loadAllShortCodes();
  }


  openModal(targetModal, dnRecord) {
    this.processing = false;
    this.dnRecordSvc.getDnRecord({ id: dnRecord.id, source: this.filterable.source.value }).pipe(first()).subscribe(data => {
      this.selectedDnRecord = data;
      this.modalService.open(targetModal, {
        windowClass: 'modal-holder'
      });
    });
  }

  clear(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable = {
      from: dte.toISOString().substring(0, 10),
      phone: '',
      to: new Date().toISOString().substring(0, 10),
      panOutState: '',
      shortCode: null,
      keyword: null,
      operator: null,
      source: null,
      country: null,
    };
    this.keywordList = [];
    this.shortCodeList = [];
    this.operatorList = [];
    this.targetShortCode = null;
    this.loadSources();
  }

  onClear(): void {
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.keywordList = [];
    this.targetShortCode = null;
  }

  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  gotoTargetShortCode(targetShortCode){
    if(targetShortCode){
      let source = this.sourceList.find(it => {return it.value == targetShortCode.source});
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.keywordList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if(targetShortCode){
        targetCountry = targetShortCode.country;
      }else{
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.shortCodeList = [];
    this.keywordList = [];
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = data.data;
        if(targetShortCode){
          this.changeOperator(targetShortCode.operator, targetShortCode);
        }
      });
    }
  }

  changeOperator(operator, targetShortCode = null) {
    if(!targetShortCode){
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.keywordList = [];
    this.filterable.shortCode = null;
    this.filterable.keyword = null;
    if (operator) {
      this.shortCodeList = this.operatorList[operator];
      if(targetShortCode){
        this.changeShortCode(targetShortCode.shortCode, targetShortCode);
      }
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    this.keywordList = [];
    this.filterable.keyword = null;
    if (shortCode) {
      this.keywordSvc.getSelectionKws(this.filterable.operator, shortCode).subscribe(data => {
        this.keywordList = data.data;
      });
    }
    if(!targetShortCode){
      this.targetShortCode = this.allShortCodes.find(it => {return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator});
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      this.filterable.source = data.data[0];
      this.countryList = data.data[0].subOptions;
      var key = Object.keys(data.data[0].subOptions)[0];
      var value = data.data[0].subOptions[key];
      this.filterable.country = value;
      this.changeCountry(value);
    });
  }

  private loadPanOutStates() {
    this.envSvc.getPanOutStates().pipe(first()).subscribe(data => {
      this.panOutList = data.data;
    });
  }

  private loadAllShortCodes(){
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if(data){
        this.allShortCodes = data.data;
      }
    });
  }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  private loadPage(page = null) {
    this.loading = true;
    this.emptyResult = false;
    this.dnRecords = [];
    let params = this.formParam(page);

    // get page of items from api
    this.dnRecordSvc.getAll(params).pipe(first()).subscribe(data => {
      if (data.status !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.dnRecords = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no record for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      phone: this.filterable.phone,
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      panOutState: this.filterable.panOutState,
      shortCode: this.filterable.shortCode,
      keyword:  this.filterable.keyword == null ? "" : this.filterable.keyword.keyword,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source.value,
    }
    console.log(params);

    return params;
  }

}
